import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	WixBiSessionSymbol,
	FeatureStateSymbol,
	SiteFeatureConfigSymbol,
	BusinessLoggerSymbol,
	ExperimentsSymbol,
	ConsentPolicySymbol,
} from '@wix/thunderbolt-symbols'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'
import { UrlHistoryManagerSymbol } from 'feature-router'
import type { IReporterInit, ReporterState } from '../types'
import { name } from '../symbols'
import { setState } from '../utils'
import { init } from './init'

const initialState: Partial<ReporterState> = {
	pageNumber: 1,
	tagManagerReady: false,
	sendDeferredPageView: () => {},
}

const reporterInit: IReporterInit = (
	featureState,
	siteConfig,
	wixBiSession,
	businessLogger,
	experiments,
	consentPolicy,
	urlHistoryManager
) => ({
	appWillMount() {
		setState(featureState, initialState)

		const shouldInitReporter = !wixBiSession.suppressbi
		if (shouldInitReporter) {
			init(
				siteConfig,
				wixBiSession,
				businessLogger,
				featureState,
				consentPolicy,
				urlHistoryManager,
				isExperimentOpen(experiments, 'fbVariantContentIds')
			)
		}
	},
})

export const ReporterInit = withDependencies(
	[
		named(FeatureStateSymbol, name),
		named(SiteFeatureConfigSymbol, name),
		WixBiSessionSymbol,
		BusinessLoggerSymbol,
		ExperimentsSymbol,
		ConsentPolicySymbol,
		UrlHistoryManagerSymbol,
	],
	reporterInit
)
